import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
  Progress,
  Spinner,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom'; // Import useParams to get the Voice ID from the URL

const FormEditVoices = () => {
  document.title = "Edit Voices | Uma Classes";
  const { id } = useParams(); // Get Voice ID from URL parameters

  const [formData, setFormData] = useState({
    title: "", // Added title field
    category: "", // Category ID here
    voiceUrl: "", // URL for the voice file
    // Add any additional fields required for the voice
  });

  const [categories, setCategories] = useState([]); // State to store categories fetched from API
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [file, setFile] = useState(null); // State to store the uploaded file
 const [uploading, setUploading] = useState(false); // Track upload state
  const [progress, setProgress] = useState(0); // Progress state for progress bar
  // Fetch categories and Voice details on component mount
  useEffect(() => {
    const fetchCategoriesAndVoice = async () => {
      try {
        const token = localStorage.getItem('token');

        // Fetch categories
        const categoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCategories(categoriesResponse); // Assuming the response contains an array of categories

        // Fetch Voice details
        const voiceResponse = await axios.get(`https://uma.aasmo.in/api/admin/getbyid-voices/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Set Voice data to form state
        const voiceData = voiceResponse; // Adjusted to get the correct data
        setFormData({
          title: voiceData.title, // Set the title for editing
          category: voiceData.category._id, // Set the category ID to match with dropdown
          voiceUrl: voiceData.voiceUrl, // Set the voice URL for editing
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories or Voice details:", error);
        setLoading(false);
      }
    };

    fetchCategoriesAndVoice();
  }, [id]); // Fetch categories and Voice details when the component mounts

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Handle file input separately
    if (e.target.files) {
      setFile(e.target.files[0]); // Set the selected file
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');

      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title); // Send the title
      formDataToSend.append('categoryId', formData.category);
      formDataToSend.append('voice', formData.voiceUrl); // Existing voice URL
      if (file) {
        formDataToSend.append('voice', file); // New file if uploaded
      }
      setUploading(true);
      setProgress(0);
      await axios.put(`https://uma.aasmo.in/api/admin/update-voices/${id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percent); // Update progress bar
        },
      });
      setUploading(false);
      setSuccessMessage("Voice Edited successfully");
      setErrorMessage(""); // Clear any previous error messages
    } catch (error) {
      setUploading(false);
      console.error("Error Editing Voice:", error);
      setSuccessMessage(""); // Clear any previous success messages
      setErrorMessage("Error Editing Voice");
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional: Edit a loading spinner or message
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Voices" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    
                    <Row className="mb-3">
                      <label htmlFor="title" className="col-md-2 col-form-label">
                        Title
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter title"
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="category" className="col-md-2 col-form-label">
                        Category
                      </label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                        >
                          <option value="">Select Category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>
                    
                    <Row className="mb-3">
                      <label htmlFor="voiceUrl" className="col-md-2 col-form-label">
                        Voice URL
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="voiceUrl"
                          name="voiceUrl"
                          value={formData.voiceUrl}
                          onChange={handleChange}
                          placeholder="Existing Voice URL"
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="voiceFile" className="col-md-2 col-form-label">
                        Upload New Voice
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="file"
                          id="voiceFile"
                          name="voiceFile"
                          accept="audio/*" // Accept audio files
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    
                    
                  {uploading && (
                    <div className="mt-3">
                      <Progress value={progress} />
                      <p>{progress}%</p>
                    </div>
                  )}
                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <div className="d-flex justify-content-start">
                      <button type="submit" className="btn btn-primary" disabled={uploading}>
                        {uploading ? <Spinner size="sm" /> : 'Save'}
                      </button>
                    </div>
                    {/* <button type="submit" className="btn btn-primary">Edit</button> */}
                    
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormEditVoices;
